import { createClient } from '@supabase/supabase-js';
import { Capacitor } from '@capacitor/core';
import { Preferences } from '@capacitor/preferences';


// --- Supabase 配置 ---
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseKey) {
    throw new Error("Supabase URL 或 KEY 未設定。");
}

// --- 1. 建立一個 "Supabase 專用" 的儲存轉接器 ---
// 這個轉接器 "只" 處理 Supabase Auth 需要的 raw strings
// 它符合 Supabase `storage` 選項需要 { getItem, setItem, removeItem } 介面
const SupabaseCapacitorStorageAdapter = {
  getItem: async (key) => {
    try {
      // Preferences.get() 返回 { value: string | null }
      const { value } = await Preferences.get({ key });
      return value;
    } catch (e) {
      console.error("SupabaseCapacitorStorage GET Error", e);
      return null;
    }
  },
  setItem: async (key, value) => {
    try {
      // value 
      await Preferences.set({ key, value });
    } catch (e) {
      console.error("SupabaseCapacitorStorage SET Error", e);
    }
  },
  removeItem: async (key) => {
    try {
      await Preferences.remove({ key });
    } catch (e) {
      console.error("SupabaseCapacitorStorage REMOVE Error", e);
    }
  },
};


// 檢查是否在原生 App 環境
const isNative = Capacitor.isNativePlatform();

const authOptions = {
  autoRefreshToken: true,
  persistSession: true,
};

if (isNative) {
  authOptions.storage = SupabaseCapacitorStorageAdapter;
}

// --- 3. 初始化 Supabase Client ---
export const supabase = createClient(supabaseUrl, supabaseKey, {
  auth: authOptions,
  db: {
    schema: 'cashbook',
  },
});
